import styled from 'styled-components';

export const Label = styled.label`
	display: block;
	margin-left: 13px;
	margin-bottom: 4px;
`;
